import { checkApp } from './appHelper';
var os = checkApp();
export var supportWebp = document
    .createElement('canvas')
    .toDataURL('image/webp')
    .indexOf('data:image/webp') == 0;
export var replaceProtocol = function (src) {
    return src.replace(/http(s?):\/\//, 'aykimghttp$1://');
};
export var replaceSuffix = function (src) {
    if (/(jpg|png|jpeg)$/.test(src)) {
        src += '.webp';
    }
    else {
        src = src.replace(/(jpg|png|jpeg?)(\??)(.*?)$/, '$1.webp$2$3');
    }
    return src;
};
export var replaceSrc = function (src) {
    if (/(jpg|png|jpeg)(\??)(.*?)$/.test(src)) {
        if (os.isApp) {
            if (os.isIOS && os.appVersion >= 55) {
                src = replaceProtocol(src);
                src = replaceSuffix(src);
            }
            if (os.isAndroid && os.appVersion > 40) {
                src = replaceSuffix(src);
            }
        }
        else if (supportWebp) {
            src = replaceSuffix(src);
        }
    }
    return src;
};
export var replaceSrcH5 = function (src) {
    if (/(jpg|png|jpeg)(\??)(.*?)$/.test(src)) {
        if (supportWebp) {
            src = replaceSuffix(src);
        }
    }
    return src;
};
export var replaceSrcApp = replaceSrc;
export var replaceSrcToNative = function (src) {
    if (/(jpg|png|jpeg)(\??)(.*?)$/.test(src)) {
        if (os.isApp) {
            if (os.isIOS && os.appVersion >= 55) {
                src = replaceSuffix(src);
            }
            else if (os.isAndroid && os.appVersion > 40) {
                src = replaceSuffix(src);
            }
        }
    }
    return src;
};
//# sourceMappingURL=webp.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aiyuke-front-lib/dist/webp.js
// module id = null
// module chunks = 